import { GLServiceBase, ServiceRoute } from "commonui";
import { ITransitionService } from ".";

class TransitionServiceClass extends GLServiceBase<any, any> implements ITransitionService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/transitions" };

	constructor() {
		super();
		this.getTransitionsStatistic = this.getTransitionsStatistic.bind(this);
	}

	getTransitionsStatistic(params: any): Promise<any> {
		return this.get("statistic", params);
	}

	createTransition(params: any): Promise<any> {
		return this.create(params);
	}

	updateTransition(params: any): Promise<any> {
		return this.update(params);
	}

	deleteTransition(params: any): Promise<any> {
		return this.delete("{transitionId}", params);
	}
}

export const TransitionService = () => new TransitionServiceClass();
export const TransitionServiceServerSidePagination = new TransitionServiceClass();
